import React from "react";
import {FormattedMessage} from "react-intl";
import styles from "./styles/style.module.scss";

const FormWrapper = ({title, children}) => {
    return (
        <div className={styles["form-wrapper"]}>
            {title && (
                <div className="form-head">
                    <h2>
                        <FormattedMessage id={title} />
                    </h2>
                </div>
            )}
            <div className="form-body">{children}</div>
        </div>
    );
};

export default FormWrapper;
